import { newRequest } from "std/api/newRequest";
import type { ApiBaseParams } from "std/api/types";
import type { EmpresaConveniadaStoreFilter } from "../store";
import type { ApiEmpresaConveniada } from "../types/ApiEmpresaConveniada";

export type ApiEmpresaConveniadaSearchParams = ApiBaseParams &
	Omit<Partial<EmpresaConveniadaStoreFilter>, "for_data_cadastro" | "for_rota"> &
	Partial<{
		for_data_cadastro_inicio: string;
		for_data_cadastro_fim: string;
		for_rota_idpk: number;
	}>;

export function apiEmpresaConveniadaSearch({
	idpk,
	params,
}: {
	idpk?: number;
	params?: ApiEmpresaConveniadaSearchParams;
}): Promise<ApiEmpresaConveniada[]> {
	return newRequest({
		url: "EmpresaConveniada/Search",
		type: "get",
		idpk,
		params,
	});
}
